import axios from 'axios';
import { getWebsiteBaseUrl, getLang } from './../../shared/utils/environment.js';
import { generateSessionId } from './../../shared/utils/auth.js';

/**
 * Create API url
 */
export const buildApiUrl = (endpoint) => {

  return getWebsiteBaseUrl() + '/orton-api/' + endpoint;

};

/**
 * Get specialists
 */
export const getSpecialists = async (args = {}) => {

  let endpoint = '_specialists?args';
  if (args.service !== null) {
    endpoint += '&service_id=' + parseInt(args.service);
  }
  if (args.language !== null) {
    endpoint += '&language_id=' + parseInt(args.language);
  }
  endpoint += '&lang=' + getLang();
  if (args.is_phone_consultation) {
    endpoint += '&type=phone';
  }
  const url = buildApiUrl(endpoint);

  const response = await axios.get(url);
  console.log('Fetch specialists: ' + url, response);
  if (response.status === 200 && response.data.data) {
    return response.data.data;
  }

};

/**
 * Get services
 */
export const getServices = async (args = {}) => {

  let endpoint = '_services?args';
  if (args.language !== null) {
    endpoint += '&language_id=' + parseInt(args.language);
  }
  endpoint += '&lang=' + getLang();
  const url = buildApiUrl(endpoint);
  const response = await axios.get(url);
  console.log('Fetch services: ' + url, response);
  if (response.status === 200 && response.data.data) {
    return response.data.data;
  }

};

/**
 * Get languages
 */
export const getLanguages = async (args = {}) => {

  let endpoint = '_languages?args';
  if (args.service !== null) {
    endpoint += '&service_id=' + parseInt(args.service);
  }
  endpoint += '&lang=' + getLang();
  const url = buildApiUrl(endpoint);
  const response = await axios.get(url);
  console.log('Fetch languages: ' + url, response);
  if (response.status === 200 && response.data.data) {
    return response.data.data;
  }

};


/**
 * Find client data
 */
export const findClient = async () => {

  const url = buildApiUrl('clients/find?session_id=' + generateSessionId());
  const response = await axios.get(url, {
    timeout: 300000
  });
  console.log('Fetch client: ' + url, response);
  if (response.status === 200 && response.data.data) {
    return response.data.data;
  }

};

/**
 * Save client data
 */
export const saveClient = async (payload) => {

  const url = buildApiUrl('_save-client?session_id=' + generateSessionId());
  const response = await axios.post(url, payload);
  console.log('Save client: ' + url, response);
  if (response.status === 200) {
    return response;
  }
  return false;

};

/**
 * Reserve appointment
 */
export const reserveAppointment = async (payload) => {

  const url = buildApiUrl('reservations?session_id=' + generateSessionId());
  const response = await axios.post(url, payload);
  console.log('Make reservation: ' + url, response);
  if (response.status === 200 && response.data.status == 200 && response.data.saved == 1 && response.data.data) {
    return response.data;
  }
  return false;

};

/**
 * Hold in-progress reservations
 */
export const addShoppingCart = async (payload) => {

  const url = buildApiUrl('_add-shopping-cart?session_id=' + generateSessionId());
  const response = await axios.post(url, payload);
  console.log('Modify shopping cart: ' + url, response);
  if (response.status === 200) {
    return true;
  }

};

/**
 * Save client data
 */
export const getAppointments = async (type) => {

  const url = buildApiUrl('_get-reservations?type=' + type + '&session_id=' + generateSessionId());
  const response = await axios.get(url);
  console.log('Fetch reservations: ' + url, response);
  if (response.status === 200 && response.data.data) {
    return response.data.data;
  }

};

/**
 * Cancel appointment
 */
export const cancelAppointment = async (payload) => {

  const url = buildApiUrl('_cancel-reservation?session_id=' + generateSessionId());
  const response = await axios.post(url, payload);
  console.log('Cancel reservation: ' + url, response);
  if (response.status === 204) {
    return true;
  }
  return false;

};

/**
 * Get timeslots
 */
export const getTimeslots = async (args) => {

  let endpoint = buildApiUrl('_timeslots');

  // ids
  endpoint += '?ids=' + args.ids.join(';');

  // to
  if (args.to) {
    endpoint += '&to=' + args.to;
  }

  // from
  if (args.from) {
    endpoint += '&from=' + args.from;
  }

  // on
  if (args.on) {
    endpoint += '&on=' + args.on;
  }

	// type: null, "phone", "reception"
	if (args.type) {
		endpoint += '&type=' + args.type;
	}

  // is_single_specialist
  if (args.is_single_specialist) {
    endpoint += '&is_single_specialist=true';
  }

  endpoint += '&lang=' + getLang();

  const response = await axios.get(endpoint);
  console.log('Fetch timeslots: ' + endpoint, response);
  if (response.status === 200 && response.data.data) {
    return response.data.data;
  }

};

/**
 * Get timeslots
 */
export const getAvailableDays = async (args) => {

  let url = buildApiUrl('_available-days');

  // ids
  url += '?ids=' + args.ids.join(';');

  // to
  if (args.to) {
    url += '&to=' + args.to;
  }

  // from
  if (args.from) {
    url += '&from=' + args.from;
  }

	// type: null, "phone", "reception"
	if (args.type) {
		url += '&type=' + args.type;
	}

  // is_single_specialist
  if (args.is_single_specialist) {
    url += '&is_single_specialist=true';
  }

  const response = await axios.get(url);
  console.log('Fetch available days: ' + url, response);
  if (response.status === 200 && response.data.data) {
    return response.data.data;
  }

};
